import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPostbank = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#postbank_svg__a)'>
      <path
        fill='#007F31'
        d='M12 24.001c6.627 0 11.999-5.373 11.999-12 0-6.628-5.372-12.001-12-12.001C5.373 0 0 5.373 0 12c0 6.628 5.372 12.001 12 12.001'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M13.511.094a12.1 12.1 0 0 0-3.133.015l.975 1.256.305.394c.407.49.763 1.128 1.788 1.584 1.234.55 2.165.42 3.01.638q.247.066.482.167c.238.115.446.28.61.486.279.315.524.622.58.695l1.046 1.304 1.742-1.746s-.406-.514-.721-.918c-.204-.249-.284-.34-.45-.44a1.8 1.8 0 0 0-.518-.213 6.5 6.5 0 0 0-1.196-.127c-1.572-.062-2.154-.188-3.15-1.386l-.744-.9-.627-.81zM8.787.435l1.265 1.63.474.608c.203.264.374.506.678.834.637.697 1.075.93 2.423 1.13 1.348.198 1.873.303 2.4.646.259.16.491.36.689.59.395.5 1.41 1.812 1.41 1.812l-1.764 1.768s-1.143-1.488-1.675-2.17c-.35-.455-.61-.844-1.095-1.216-.844-.637-1.82-.571-2.857-.694-.653-.076-1.288-.09-2.268-1.343l-.68-.885-1.374-1.767-.172.092A12 12 0 0 1 8.78.435zM5.175 2.132l1.357 1.749s.181.241.827 1.07.954.897.954.897c.722.345 1.277.357 1.878.42.702.074 1.389-.008 2.161.546.375.269.884.928 1.204 1.35.655.862 1.785 2.316 1.785 2.316l-1.764 1.767-1.931-2.527c-.594-.765-.73-.953-1.44-1.776-.593-.685-1.612-.773-3.48-1.113 0 0-.895-.087-1.524-.72a7 7 0 0 1-.63-.744L3.305 3.734a12 12 0 0 1 1.87-1.602M2.352 4.866l1.15 1.48q.152.194.325.371c.813.835 2.181 1.003 2.181 1.003.37.063 1.988.136 2.72.753.334.283.883.984 1.641 1.96.677.874 2.205 2.821 2.205 2.821l-1.82 1.823S7.097 10.2 6.723 9.762c-.407-.481-1.008-1.188-2.576-1.114 0 0-.17.013-.407.024a4.8 4.8 0 0 1-1.124-.061 1.4 1.4 0 0 1-.268-.083 1.7 1.7 0 0 1-.407-.257 3 3 0 0 1-.264-.266l-.035-.044-.622-.8c.358-.812.805-1.581 1.333-2.295'
        clipRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='postbank_svg__a'>
        <path fill='#fff' d='M0 0h23.999v24.001H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgPostbank)
export default ForwardRef
